import request from "@/utils/request";

//统计团队的所有数据
export function getTeamAllData(params, config) {
    return request.get('/front/index/statisticsAllTeamData', params, config)
}


//统计团队数据
export function getTeamData(params, config) {
    return request.get('/front/index/statisticsTeamData', params, config)
}


// 统计当前团队的数据
export function getCurrentTeamData(params, config) {
    return request.get('/front/index/statisticsCurrentTeamData', params, config)
}


//获取公告列表信息
export function queryNoticeList(params, config) {
    return request.get('/mailNotice/queryNoticeList', params, config)
}

//图表结构
export function statisticsIndexTeamDetailData(params, config) {
    return request.post('/front/index/statisticsIndexTeamDetailData', params, config)
}